import styled from "@emotion/styled";
import type { HTMLAttributes } from "react";

import * as MediaIcons from "../icons/media";

export const MediaIconContainer = styled.div`
  display: flex;
  align-items: center;
  max-width: 100%;
  max-height: 100%;

  > svg {
    max-width: 100%;
    max-height: 100%;
  }
`;

const EmptyMediaSlot = styled.div`
  width: 90px;
  height: 90px;
  background: url(/assets/EmptyMediaSlot.svg) no-repeat center/contain;
  opacity: 0.5;
`;

type Props = {
  type?: MediaIconType;
} & HTMLAttributes<HTMLDivElement>;

export const MediaIcon = ({ type, ...rest }: Props) => {
  const IconComponent = type && MediaIcons[type];
  return (
    <MediaIconContainer {...rest}>
      {IconComponent ? <IconComponent role="image" /> : <EmptyMediaSlot role="image" />}
    </MediaIconContainer>
  );
};

export type MediaIconType =
  | "Activity"
  | "Animation"
  | "ArModel"
  | "AssessmentReport"
  | "AudioMusic"
  | "AudioVoiceOver"
  | "BlendClassroom"
  | "BlendPhysicalExercise"
  | "BlendVerbalExercise"
  | "BlendVirtualReality"
  | "ComposedScreens"
  | "EmptySlot"
  | "GroupActivity"
  | "Grouping"
  | "HtmlActivity"
  | "ImageRaster"
  | "ImageVector"
  | "ListQuestion"
  | "MatchingQuestion"
  | "Menu"
  | "MultiSelect1"
  | "MultiSelect2"
  | "MultiSelect3"
  | "MultiSelectImage"
  | "NavGroup"
  | "OpenResponse"
  | "OrderingQuestion"
  | "Pinboard"
  | "Pinpoint"
  | "Question"
  | "SingleSelect1"
  | "SingleSelect2"
  | "SingleSelect3"
  | "SingleSelectImage"
  | "Slides"
  | "SlidesQuestion"
  | "Text"
  | "Video"
  | "VrActivity";
